<template>
	<type-wrapper class="type-B" regular :bgImage="showData.image" :bgColor="showData.bg_color" @mousemove="hoverMove">
		<!-- 如果存在3D模型 -->
		<template v-if="hasTdModel">
			<type-grid row="25" margin>
				<type-text type="title" size="2" v-if="showData.title">{{ showData.title }}</type-text>
				<type-image mode="widthFix" :src="mainPicture"></type-image>
				<type-button round style="margin: 30px 0;" :style="buttonStyle[0]" :whitebackdrop="whitebackdrop" @click="jumpAction(showData)" v-if="showData.is_button">{{ showData.btn_text }}</type-button>
				<template v-for="(item, index) in showData.block">
					<div :key="index">
						<type-text type="title" size="4" align="left" weight="bold" v-if="item.title">{{ item.title }}</type-text>
						<type-text type="content" size="6" v-if="item.content">{{ item.content }}</type-text>
					</div>
				</template>
			</type-grid>
			<type-grid :class="tdModelClass" row="35" margin>
				<div class="thredD-model-content">
					<vue-3d-loader
						ref="model"
						:scale="scale"
						:filePath="filePath"
						:enableDamping="enableDamping"
						:dampingFactor="dampingFactor"
						:backgroundColor="backgroundColor"
						:backgroundAlpha="backgroundAlpha"
						:controlsOptions="controlsOptions"
						:position="dynamicData.objectPosition"
						:rotation="dynamicData.objectRotation"
						:cameraPosition="dynamicData.cameraPosition"
						:cameraRotation="dynamicData.cameraRotation"
						@load="modelLoad"
						@mouseup="onMouse('up', arguments)"
						@mousedown="onMouse('down', arguments)"
						@mousemove="onMouse('move', arguments)">
					</vue-3d-loader>
				</div>
			</type-grid>
		</template>
		<!-- 正常模式(左图右文) -->
		<template v-else>
			<type-grid row="11" margin v-if="showData.title">
				<type-text type="title" size="max">{{ showData.title }}</type-text>
			</type-grid>
			<type-grid class="thredD-model-container" row="23" margin style="text-align: center;" v-if="mainPicture">
				<type-image mode="widthFix" :src="mainPicture"></type-image>
				<type-button round style="margin-top: 20px;" :style="buttonStyle[0]" :whitebackdrop="whitebackdrop" @click="jumpAction(showData)" v-if="showData.is_button">{{ showData.btn_text }}</type-button>
			</type-grid>
			<type-grid :row="mainPicture ? '13' : '11'" margin>
				<template v-for="(item, index) in showData.block">
					<div :key="index">
						<type-text type="title" size="5" align="left" weight="bold" v-if="item.title">{{ item.title }}</type-text>
						<type-text type="content" size="9" v-if="item.content">{{ item.content }}</type-text>
					</div>
				</template>
			</type-grid>
		</template>
	</type-wrapper>
</template>

<script>
	// 二分左文右图
	import mixin from '../mixin.js'
	import index from '../mixin-bc.js'
	export default {
		name: 'type-B',
		mixins: [ mixin, index ]
	}
</script>

<style scoped lang="less">
	.type-B{
		display: flex;
		flex-wrap: wrap;
		align-items: flex-start;
		// .thredD-model-container{
		// 	background-color: red;
		// 	.thredD-model-content{
		// 		background-color: rgba(0, 0, 0, .75);
		// 	}
		// }
	}
	@media screen and (min-width: 720px){
		.thredD-model-container{
			// aspect-ratio: 1/1;
			.thredD-model-content{
				position: absolute;
				top: 50%;
				left: 50%;
				width: 100%;
				height: 150%;
			}
		}
		.layout-normal{
			position: relative;
			.thredD-model-content{
				transform: translate(-50%, -60%);
			}
		}
		.layout-sticky{
			position: sticky;
			top: 50%;
			z-index: 100;
			transform: translateY(-50%);
			.thredD-model-content{
				transform: translate(-50%, -50%);
			}
		}
	}
	@media screen and (max-width: 719px){
		.thredD-model-container{
			// aspect-ratio: 1/1.5;
			.thredD-model-content{
				width: 100%;
				height: 100%;
			}
		}
	}
</style>
